import { render } from "react-dom";
import {
	NetworkErrorBoundary,
	SubscriptionManager,
	PollingSubscription,
	DevToolsManager
} from "rest-hooks";
import { CacheProvider, NetworkManager } from "@rest-hooks/core";
import { AuthManager } from "@ploy-lib/rest-resources";

import App from "./App";
import { ErrorPageHandler } from "./components/ErrorPageHandler";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/v4-shims.css";
import { EnvProvider } from "@ploy-lib/core";
import {
	BrandTenantProvider,
	DefaultLinearProgress,
	GlobalSuspenseProvider
} from "@ploy-ui/core";
import { LinearProgress, CssBaseline, Box } from "@material-ui/core";
import { HiddenInProductionTenantSelector } from "@ploy-ui/tenants";
import { BrowserRouter } from "react-router-dom";

const basepath = process.env.PUBLIC_URL;

const managers = [
	new AuthManager(),
	new NetworkManager(15 * 60 * 1000),
	new SubscriptionManager(PollingSubscription)
];

if (process.env.NODE_ENV !== "production")
	managers.unshift(new DevToolsManager());

function renderApp() {
	render(
		<EnvProvider
			envFilter={env => env.includes("portal") || env.includes("internal")}
		>
			<CacheProvider managers={managers}>
				<GlobalSuspenseProvider
					// Fallback before the actual theme is fully loaded
					fallback={
						<>
							<DefaultLinearProgress />
							<CssBaseline />
							<HiddenInProductionTenantSelector />
						</>
					}
				>
					<NetworkErrorBoundary
						fallbackComponent={() => (
							<>
								<CssBaseline />
								<HiddenInProductionTenantSelector />
							</>
						)}
					>
						<BrandTenantProvider defaultLocale="nb-NO" defaultCurrency="NOK">
							<GlobalSuspenseProvider
								fallback={
									<Box zIndex="tooltip" clone>
										<LinearProgress color="primary" />
									</Box>
								}
							>
								<BrowserRouter basename={basepath}>
									<ErrorPageHandler>
										<App />
									</ErrorPageHandler>
								</BrowserRouter>
							</GlobalSuspenseProvider>
							<CssBaseline />
							<HiddenInProductionTenantSelector />
						</BrandTenantProvider>
					</NetworkErrorBoundary>
				</GlobalSuspenseProvider>
			</CacheProvider>
		</EnvProvider>,
		document.getElementById("root")
	);
}

renderApp();
